import createIcon from "./createIcon";

const AddPlusIcon = createIcon(
  "M5.75 11.5H11.5M11.5 11.5H17.25M11.5 11.5V17.25M11.5 11.5V5.75",
  "#12B76A",
  "1.2",
  "0 0 23 23"
);

export default AddPlusIcon;
